// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__2MCTN","message":"CookieConsent_message__3P79X","cookieLink":"CookieConsent_cookieLink__19en_","continueBtn":"CookieConsent_continueBtn__1WMC9"};